import {extendTheme} from '@chakra-ui/react';
import {mode} from "@chakra-ui/theme-tools"
import {themecolors} from "../utils/themecolors";

const FormLabel = {
    baseStyle: (props) => ({
        fontSize: "14px",
        color: mode(`${themecolors.light_high_impact_text} !important`, `${themecolors.dark_high_impact_text} !important`)(props),
    }),
};

const Form = {
    baseStyle: (props) => ({
        helperText: {
            color: mode(themecolors.light_medium_impact_text, themecolors.dark_medium_impact_text)(props),
        },
    }),
};

const Alert = {
    baseStyle: {
        title: {
            fontWeight: 500,
        },
    },
    variants: {
        homefeed: (props) => {
            return {
                container: {
                },
                description: {
                    color: mode('rgb(89, 96, 104)', '#d0d0d0')(props),
                },
            };
        }
    },
};

const Accordion = {
    baseStyle: (props) => ({
        container: {
            borderBottom: 'none',
            _first: {
                borderTop: 'none',
            }
        },
    }),
};

const Button = {
    baseStyle: (props) => ({
        color: '#fff',
        bg: '#3182ce',
    }),
    variants: {
        blue: (props) => ({
            fontSize: '15px',
            fontWeight: 500,
            height: '36px',
            bg: mode('#0c0c0c', '#f3f3f3')(props),
            borderRadius: '4px',
            padding: '0 24px',
            color: mode('#fff', themecolors.light_high_impact_text)(props),
            _hover: {
                bg: mode('#0c0c0c', '#fff')(props),
                _disabled: {
                    bg: mode('#363636', '#fff')(props),
                }
            }
        }),
        grey: (props) => ({
            fontSize: '15px',
            fontWeight: 500,
            height: '36px',
            bg: mode(themecolors.lighter_border, '#272728')(props),
            borderRadius: '4px',
            padding: '0 24px',
            color: mode(themecolors.light_high_impact_text, themecolors.dark_high_impact_text)(props),
            _hover: {
                bg: mode(themecolors.light_border, '#2d2d2e')(props),
                _disabled: {
                    bg: mode('#d2d4da', '#2d2d2e')(props),
                }
            }
        }),
        cancel: (props) => ({
            color: mode(themecolors.light_low_impact_text, themecolors.dark_low_impact_text)(props),
            bg: 'transparent',
            padding: '0 12px',
            fontSize: '15px',
            fontWeight: 500,
        }),
        viewArchive: (props) => ({
            fontSize: '13px',
            fontWeight: 500,
            bg: mode('#ececec', '#272728')(props),
            borderRadius: '6px',
            padding: '0 20px',
            height: '34px',
            color: mode('#1e1e1e', '#fff')(props),
            _hover: {
                bg: mode('#d2d4da', '#2d2d2e')(props),
            }
        }),
        save: (props) => ({
            color: '#fff',
            bg: '#307ad5',
            borderRadius: 50,
            fontWeight: 500,
            padding: '0 24px',
            _hover: {
                _disabled: {
                    bg: '#3182ce',
                },
            },
        }),
        save2: (props) => ({
            color: '#000',
            fontSize: '14px',
            fontWeight: 'normal',
            bg: '#f7f7f7',
            padding: '0 24px',
            borderRadius: '40px',
            _hover: {
                _disabled: {
                    bg: '#3182ce',
                },
            },
        }),
        none: (props) => ({
            color: 'black',
            bg: 'none',
        }),
        support: (props) => ({
            fontSize: '15px',
            bg: mode('#f6f7f6', '#343536')(props),
            color: mode('rgb(94 97 101)', '#fff')(props),
            _hover: {
                bg: mode('#eaeaea', '#424345')(props),
            }
        }),
    },
};

const Tag = {
    variants: {
        topic: (props) => {
            return {
                container: {
                    bg: mode('rgba(0, 0, 0, .05)', 'rgba(255, 255, 255, .05)')(props),
                }
            };
        }
    },
    defaultProps: {
        variant: "topic"
    }
};

const Menu = {
    variants: {
        default: (props) => {
            return {
                list: {
                    color: mode('inherit', '#fff'),
                    bg: mode('white', '#161616')(props),
                    border: mode('1px solid rgb(219, 219, 219)', '1px solid #222222')(props),
                    borderRadius: '4px',
                    fontSize: '15px',
                },
                item: {
                    _hover: {
                        bg: '#80808012',
                    },
                    _focus: {
                        bg: '#80808012',
                    },
                },
            };
        },
        profileMenu: (props) => {
            return {
                list: {
                    color: mode('inherit', '#fff'),
                    bg: mode('white', '#161616')(props),
                    border: mode('1px solid rgb(219, 219, 219)', '1px solid #222222')(props),
                    borderRadius: '4px',
                    fontSize: '15px',
                },
                item: {
                    padding: '8px 58px',
                    _hover: {
                        bg: '#80808012',
                    },
                    _focus: {
                        bg: '#80808012',
                    },
                },
            };
        }
    },
    defaultProps: {
        variant: "default"
    }
};

const Modal = {
    baseStyle: (props) => ({
        dialog: {
            borderRadius: '6px',
            color: mode('inherit', '#fff'),
            bg: mode('white', themecolors.dark_background_1)(props),
            border: mode('none', '1px solid #343536')(props),
        },
        header: {
            fontWeight: '600',
        },
        closeButton: {
            padding: '20px',
            fontSize: '13px',
        },
        footer: {
          borderTop: mode('1px solid #f2f2f2', '1px solid #343536')(props),
        },
    }),
};

const Input = {
    baseStyle: (props) => ({
        field: {
            _placeholder: {
                color: mode(themecolors.light_low_impact_text, themecolors.dark_low_impact_text)(props),
            },
            fontSize: '15px',
        },
    }),
    sizes: {
        md: {
            field: {
                borderRadius: '4px',
                fontSize: '15px',
            },
        },
    },
};

const Select = {
    sizes: {
        md: {
            field: {
                borderRadius: '4px',
                fontSize: '15px',
            },
        },
    },
};

const Textarea = {
    baseStyle: (props) => ({
        _placeholder: {
            color: mode(themecolors.light_low_impact_text, themecolors.dark_low_impact_text)(props),
        },
        fontSize: '15px',
    }),
    sizes: {
        md: {
            borderRadius: '4px',
            fontSize: '15px',
        },
    },
};


export default extendTheme({
    fonts: {
        heading: "'Roboto Flex', arial, sans-serif",
        body: "'Roboto Flex', arial, sans-serif",
    },
    colors: {
        gray: {
            50: "#f9f9f9",
            100: "#f2f2f2",
            200: "#e5e5e5",
            300: "#d4d4d4",
            400: "#a3a3a3",
            500: "#737373",
            600: "#525252",
            700: "#404040",
            800: "#262626",
            900: "#171717",
        },
    },
    styles: {
        global: (props) => ({
            body: {
                bg: 'transparent',
            },
        }),
    },
    components: {
        Modal,
        Button,
        Menu,
        Tag,
        Accordion,
        Alert,
        Input,
        Select,
        Textarea,
        Form,
        FormLabel,
    },
});
